import { render, staticRenderFns } from "./ArticleTags.vue?vue&type=template&id=35d0339a"
import script from "./ArticleTags.vue?vue&type=script&lang=ts"
export * from "./ArticleTags.vue?vue&type=script&lang=ts"
import style0 from "./ArticleTags.vue?vue&type=style&index=0&id=35d0339a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports